<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Inventory \ <span class="ActiveURL">Upload New Invenotry</span></span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Upload New Invenotry</h6>

        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link> -->
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>
                  <!-- Email


                <d-col md="12" class="form-group row">
                   <a-steps>
    <a-step status="finish" title="Login">
      <a-icon slot="icon" type="user" />
    </a-step>
    <a-step status="finish" title="Verification">
      <a-icon slot="icon" type="solution" />
    </a-step>
    <a-step status="process" title="Pay">
      <a-icon slot="icon" type="loading" />
    </a-step>
    <a-step status="wait" title="Done">
      <a-icon slot="icon" type="smile-o" />
    </a-step>
  </a-steps>
                </d-col> -->

                 <d-col md="12" class="form-group row" >
                    <label class="col-md-3 col-form-label">Panel *</label>
                    <div class="col-md-4">
                      <select class="form-control" @change="panelOnchange()" v-model="GenericUpload.DataModel.Data.PanelInfo">
                    <option style="padding:50px" v-for="Dropdown in GenericUpload.Masters.PanelList" :value="Dropdown"
                      :key="Dropdown.ReferenceNo" >{{ Dropdown.Name }}</option>
                    </select>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Generic Input file *</label>
                    <div class="col-md-7" v-if="GenericUpload.DataModel.UIData.UploadedDataCount == 0">   
                     <!-- <ejs-uploader ref="uploadObj" :uploading="importExcel"   id='Noonfileupload' name="UploadFiles"></ejs-uploader> -->
                         <div class="button_group">


                          <a v-if="GenericUpload.DataModel.Data.PanelInfo.Panel=='Amazon'" href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>

                          <a v-if="GenericUpload.DataModel.Data.PanelInfo.Panel=='Noon'" href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          <input type="file" id="avatar" @change="importNoonExcel" name="avatar">
                          </a>

                          <a v-if="GenericUpload.DataModel.Data.PanelInfo.Panel=='StoreUS'" href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          <input type="file" id="avatar" @change="importStoreUSExcel" name="avatar">
                          </a>

                          <a v-if="GenericUpload.DataModel.Data.PanelInfo.Panel=='Jokoka'" href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          <input type="file" id="avatar" @change="importJokokaExcel" name="avatar">
                          </a>

                          <d-button type="button" id="submit" title="Please Select the panel"  class="btn-accent" @click="getQuery" style="margin-right:10px" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>

                          


                    </div>
                     <div class="col-md-7" v-if="GenericUpload.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ GenericUpload.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>
                      <!-- 
                        <div class style="text-align:center">
                        <d-button type="button" id="submit" title="Please Select the panel" :disabled="( GenericUpload.DataModel.Data.FromCountry ==null)" class="btn-accent" @click="GenericUploadData" style="margin-right:10px" >upload Data</d-button>
                        <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                        </div>   -->

                 <d-col md="12" class="form-group row" v-if="(GenericUpload.DataModel.UIData.UploadedDataCount > 0 && GenericUpload.DataModel.Data.GenericInputCount > 0)">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{GenericUpload.DataModel.Data.GenericInputCount}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row" v-if="GenericUpload.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from table</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{GenericUpload.DataModel.UIData.UploadedDataCount}}</label>
                    </div>
                 </d-col>

       

         

                  <d-col md="12" class="form-group row" v-if="GenericUpload.DataModel.UIData.Progressed > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Updated </label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{GenericUpload.DataModel.UIData.Progressed}}</label>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row" v-if="GenericUpload.DataModel.UIData.TemplateIsAvailable">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="GenericUpload.DataModel.UIData.Template"  :name="GenericUpload.DataModel.UIData.FileName"><span style="marige-top:10px;" > Download Data </span>   </download-excel>
                    </d-button>
                    </div>
                  </d-col>


                  <d-col md="12" class="form-group row"  v-if="GenericUpload.DataModel.UIData.GenericInputTemplateCount" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="GenericUpload.DataModel.UIData.GenericInputTemplate"  :name="GenericUpload.DataModel.UIData.FileName"><span style="marige-top:10px;" > Download Generic Data </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                <d-col md="12" class="form-group row"  v-if="GenericUpload.DataModel.UIData.TemplateIsAvailable" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="GenericUpload.DataModel.UIData.AvailablityList"  :name="GenericUpload.DataModel.UIData.AvailabilityTemplateFileName"><span style="marige-top:10px;" > Download Availability Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
                <d-col md="12" class="form-group row"  v-if="GenericUpload.DataModel.UIData.TemplateIsAvailable" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="GenericUpload.DataModel.UIData.minMaxList"  :name="GenericUpload.DataModel.UIData.MinMaxFileName"><span style="marige-top:10px;" > Download Price min & max Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
          <d-col md="12" class="form-group row"  v-if="GenericUpload.DataModel.UIData.RejectedList.length" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="GenericUpload.DataModel.UIData.RejectedList"  name="RejectedList"><span style="marige-top:10px;" > Download Rejected List </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                                   
                  

                  <!--  
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Amazon File</label>
                    <div class="col-md-7">
                     <ejs-uploader ref="uploadObj" id='Amazonfileupload' name="UploadFiles"></ejs-uploader>
                    </div>
                  </d-col> -->

                </d-form-row>
                 <!-- <d-button type="button" id="submit" class="btn-accent" @click="getQuery">run</d-button> -->
                <br />
                <div class style="text-align:center"  v-if="GenericUpload.DataModel.UIData.UploadedDataCount >0 && GenericUpload.DataModel.UIData.IsSTWRequest==false">
                  <d-button type="button" id="submit" title="Please Select the panel" :disabled="(GenericUpload.DataModel.Data.PanelInfo.Country == null || GenericUpload.DataModel.Data.FromCountry ==null || GenericUpload.DataModel.UIData.TemplateIsAvailable)" class="btn-accent" @click="GetList" style="margin-right:10px" >Submit</d-button>
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>
                <div class style="text-align:center"  v-if="GenericUpload.DataModel.UIData.IsSTWRequest==true">
                  <d-button type="button" id="submit" title="Please Select the panel" v-if="GenericUpload.DataModel.UIData.Progressed == 0"  :disabled="(GenericUpload.DataModel.UIData.GenericInputTemplateCount==0)" class="btn-accent" @click="UpdateSTWPricing" style="margin-right:10px" >Update STW</d-button>
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>


              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="GenericUpload.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
export default {
  name: 'GenericUpload',
   data() {
    return {
      GenericUpload: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            PanelInfo:{
              Name:null,
              Country:null
            },
            FromCountry:null,
            GenericInputCount:[],
            Token:null,
            Curd:null,
            CreatedBy:0,
            
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            IsSTWRequest:false,
            currentStep:0,
            Template:[],
            minMaxList:[],
            Progressed:0,
            GenericInputTemplate:[],
            RejectedList:[],
            AvailablityList:[],
            GenericInputTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            },            {
              Name : "STW All Country",
              Country:"All_Country",
              Panel:"STW"
            }

          ]
        },
      },
    };
  },

  mounted(){
      this.GenericUpload.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.GenericUpload.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.GenericUpload.DataModel.Data.FromCountry = null;
     document.getElementById("pricing").reset();
     this.GenericUpload.DataModel.UIData.IsSTWRequest = false;
},

panelOnchange(){


            this.GenericUpload.DataModel.UIData.Template=[];
            this.GenericUpload.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.GenericUpload.DataModel.UIData.Template = [];
            this.GenericUpload.DataModel.UIData.TemplateIsAvailable = false;
            this.GenericUpload.DataModel.Data.GenericInputCount = 0;
            this.GenericUpload.DataModel.UIData.UploadedDataCount = 0;
            this.GenericUpload.DataModel.UIData.GenericInputTemplateCount=false;
            this.GenericUpload.DataModel.UIData.Progressed = 0;
            this.GenericUpload.DataModel.UIData.RejectedList=[];
            this.GenericUpload.DataModel.UIData.IsSTWRequest = false;
        this.GenericUpload.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.GenericUpload.DataModel.Data.FromCountry =null;
        this.GenericUpload.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
      },

      ListAllFromCountry(){
      let vm = this;
      vm.GenericUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.GenericUpload.DataModel.Data.Token = Token;
      this.GenericUpload.DataModel.Data.CRUD = "ListAllFromCountry";
      var dataString = JSON.stringify(this.GenericUpload.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.GenericUpload.PageLoad = false;
            vm.GenericUpload.Masters.CountryMaster = response.data.Result;
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.GenericUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },


getQuery()
{
        let vm = this;
      vm.GenericUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.GenericUpload.DataModel.Data.Token = Token;
      if(this.GenericUpload.DataModel.Data.PanelInfo.Panel=="Amazon")
      this.GenericUpload.DataModel.Data.CRUD = "UploadInventory";
      else if(this.GenericUpload.DataModel.Data.PanelInfo.Panel=="Noon")
      this.GenericUpload.DataModel.Data.CRUD = "UploadNoonInventory";
      else if(this.GenericUpload.DataModel.Data.PanelInfo.Panel=="Jokoka")
      this.GenericUpload.DataModel.Data.CRUD = "UploadJokokaInventory";
      else if(this.GenericUpload.DataModel.Data.PanelInfo.Panel=="StoreUS")
      this.GenericUpload.DataModel.Data.CRUD = "UploadStoreUSInventory";
      
      var dataString = JSON.stringify(this.GenericUpload.DataModel.Data);

      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.GenericUpload.PageLoad = false;
            vm.GenericUpload.DataModel.UIData.UploadedDataCount= vm.GenericUpload.DataModel.Data.GenericInputCount;
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.GenericUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},



      GetList(){
      let vm = this;
      vm.GenericUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.GenericUpload.DataModel.Data.Token = Token;
      
      this.GenericUpload.DataModel.UIData.FileName = this.GenericUpload.DataModel.Data.PanelInfo.Name + " " + Date.now();
      this.GenericUpload.DataModel.UIData.AvailabilityFileName = this.GenericUpload.DataModel.Data.PanelInfo.Name + "UnAvailability" + " " + Date.now();
      this.GenericUpload.DataModel.UIData.AvailabilityTemplateFileName = this.GenericUpload.DataModel.Data.PanelInfo.Name + "Availability" + " " + Date.now();
      this.GenericUpload.DataModel.UIData.MinMaxFileName = this.GenericUpload.DataModel.Data.PanelInfo.Name + "Min and Max Pricing" + " " + Date.now();
      this.GenericUpload.DataModel.Data.CreatedBy = this.GenericUpload.SessionInfo.PageInfo.userId;
      var ListParameter = Utilities.JsonCopy(this.GenericUpload.DataModel.Data);

      ListParameter.GenericInputCount = [];
      var dataString = null;
        

        // ListParameter.CRUD = "GetVtexList";
        // dataString = JSON.stringify(ListParameter);
        // this.GetVtexList(dataString);
       if(this.GenericUpload.DataModel.Data.PanelInfo.Panel == "STW")
       {
        ListParameter.CRUD = "GetSTWInputList";
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);

       }
       else if(this.GenericUpload.DataModel.Data.PanelInfo.Panel == "Jokoka")
       {
          ListParameter.CRUD = "GetGenericJokokaInputList";
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);
       }
       else if(this.GenericUpload.DataModel.Data.PanelInfo.Panel == "StoreUS")
       {
          ListParameter.CRUD = "GetGenericStoreUSInputList";
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);
       }
       else
       {
          ListParameter.CRUD = "GetGenericInputList";
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);
       }

        



      },


      GenericUploadData(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.GenericUpload.DataModel.Data.Token = Token;
      this.GenericUpload.DataModel.Data.CRUD = "Create";
      this.GenericUpload.DataModel.UIData.FileName = this.GenericUpload.DataModel.Data.PanelInfo.Name + " " + Date.now();
      var dataString = JSON.stringify(this.GenericUpload.DataModel.Data);
       vm.GenericUpload.PageLoad = true;
       vm.GenericUpload.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.GenericUpload.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
              console.log(response.data.Result);  
            vm.GenericUpload.DataModel.UIData.UploadedDataCount = response.data.Result;
            

          } else {
              console.log(response.data.ErrorInfo);
              vm.GenericUpload.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.GenericUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },


 
  // UploadedDataCount
  

      GetGenericInputList(dataString){
       let vm = this;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.GenericUpload.PageLoad = false;
            vm.$toaster.success("Successfully Generated.");
            vm.GenericUpload.DataModel.UIData.GenericInputTemplate= response.data.Result              
            if(vm.GenericUpload.DataModel.UIData.GenericInputTemplate.length > 0)
            vm.GenericUpload.DataModel.UIData.GenericInputTemplateCount = true;
            vm.GenericUpload.DataModel.UIData.IsSTWRequest=true;

            // vm.GenericUpload.DataModel.UIData.GenericInputTemplate 

          } else {
              console.log(response.data.ErrorInfo);
                vm.GenericUpload.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Data !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.GenericUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },

  
    AmazonTemplate(dataString){
       let vm = this;
        vm.GenericUpload.DataModel.Data.CRUD = "GetAmazonList";
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.GenericUpload.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);

            response.data.Result.map(function(key,value){

                key.minimum_Buybox_seller_allowed_price=Math.ceil(key.price - ((10/100) * key.price));	
                key.maximum_Buybox_seller_allowed_price=Math.ceil(Number((10/100) * key.price) + Number(key.price));

            });

            vm.GenericUpload.DataModel.UIData.Template = response.data.Result;
            
            if(vm.GenericUpload.DataModel.UIData.Template.length > 0)
            vm.GenericUpload.DataModel.UIData.TemplateIsAvailable = true;
          } else {
              console.log(response.data.ErrorInfo);
                vm.GenericUpload.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.GenericUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },


    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */






     importExcel(e) {

      const files = e.target.files;
      this.GenericUpload.PageLoad = true;
      this.GenericUpload.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.GenericUpload.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the dat   a of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000


          this.GenericUpload.DataModel.Data.GenericInputCount = 0 ;
          this.GenericUpload.DataModel.Data.QueryString = "INSERT INTO `AllInventoryTemp` (`ASIN`, `SKU`, `Price`, `Quantity`,`Panel`,`IsActive`,`CreatedBy`) VALUES";


          // for (var i = 0; i < loopCount; i++) {

          // }


          for (var i = 0; i < ws.length; i++) {


            var ScrabData={
              ASIN:null,
              SKU:null,
              quantity:0,
              price:0
            }

            if(ws[i].asin1 !=undefined)
            {
                ScrabData.ASIN = ws[i].asin1;
            }
            else
            {
              ScrabData.ASIN = null;
            }

            
            if(ws[i].sku !=undefined )
            {
                 ScrabData.SKU = ws[i].sku;
            }
            else
            {
                ScrabData.SKU = null;
            }

            if(ws[i].price !=undefined )
            {
                 ScrabData.price = ws[i].price;
            }
            else
            {
                ScrabData.price = 0;
            }
            if(ws[i].quantity !=undefined)
            {
                ScrabData.quantity = ws[i].quantity;
            }
            else
            {
              ScrabData.quantity = null;
            }

             ScrabData.CreatedBy = this.GenericUpload.SessionInfo.PageInfo.userId;

            this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString + "(\'" + ScrabData.ASIN + "\',\'" +ScrabData.SKU + "\',\'" +ScrabData.price + "\',\'" +ScrabData.quantity + "\',\'" +this.GenericUpload.DataModel.Data.PanelInfo.Name + "\',\'1\' ,\'" + ScrabData.CreatedBy + "\')";

            if(i < (ws.length - 1))
            {
              this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString+"," 
            }
            this.GenericUpload.DataModel.Data.GenericInputCount +=1;
            
            // this.GenericUpload.DataModel.Data.GenericInputCount.push(ScrabData);
            //  excellist.push(ws[i]);
          }

          
           this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString+";"
          // console.log("Read results", this.GenericUpload.DataModel.Data.GenericInputCount); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log(this.GenericUpload.DataModel.Data.QueryString);  
          this.GenericUpload.PageLoad = false;
        //   console.log(this.GenericUpload.DataModel.Data.QueryString); 
          // this.GenericUpload.DataModel.Data.QueryString = JSON.stringify(this.GenericUpload.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            this.GenericUpload.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },	


 importNoonExcel(e) {

      const files = e.target.files;
      this.GenericUpload.PageLoad = true;
      this.GenericUpload.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.GenericUpload.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the dat   a of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000


          this.GenericUpload.DataModel.Data.GenericInputCount = 0 ;
          
          this.GenericUpload.DataModel.Data.QueryString = "INSERT INTO `AllNoonInventoryTemp` (`country_code`, `id_partner`, `partner_sku`, `partner_barcodes`, `psku_code`, `noon_sku`, `price`, `sale_price`, `noon_price_min`, `noon_price_max`, `seller_price_min`, `seller_price_max`,   `is_active`, `warranty`, `stock_fbn_net`, `stock_xdock_gross`, `stock_xdock_net`, `mp_code`, `noon_status`,`Panel`,`createdBy`) VALUES ";


          // for (var i = 0; i < loopCount; i++) {

          // }


          for (var i = 0; i < ws.length; i++) {
            var ScrabData={
              country_code:null,	
              id_partner:null,		
              partner_sku:null,	
              partner_barcodes:null,	
              psku_code:null,	
              noon_sku:null,	
              price:null,	
              sale_price:null,	
              noon_price_min:null,	
              noon_price_max:null,	
              seller_price_min:null,	
              seller_price_max:null,	
              is_active:null,	
              warranty:null,	
              stock_fbn_net:null,	
              stock_xdock_gross:null,	
              stock_xdock_net:null,	
              mp_code:null,	
              noon_status:null,
            }

            if(ws[i].country_code !=undefined)
            {
                ScrabData.country_code = ws[i].country_code;
            }
            else
            {
              ScrabData.country_code = null;
            }

            if(ws[i].id_partner !=undefined)
            {
                ScrabData.id_partner = ws[i].id_partner;
            }
            else
            {
              ScrabData.id_partner = null;
            }

            if(ws[i].partner_sku !=undefined)
            {
                ScrabData.partner_sku = ws[i].partner_sku;
            }
            else
            {
              ScrabData.partner_sku = null;
            }
                if(ws[i].partner_barcodes !=undefined)
            {
                ScrabData.partner_barcodes = ws[i].partner_barcodes;
            }
            else
            {
              ScrabData.partner_barcodes = null;
            }
                if(ws[i].psku_code !=undefined)
            {
                ScrabData.psku_code = ws[i].psku_code;
            }
            else
            {
              ScrabData.psku_code = null;
            }
                if(ws[i].noon_sku !=undefined)
            {
                ScrabData.noon_sku = ws[i].noon_sku;
            }
            else
            {
              ScrabData.noon_sku = null;
            }
          
                if(ws[i].price !=undefined)
            {
                ScrabData.price = ws[i].price;
            }
            else
            {
              ScrabData.price = null;
            }
                if(ws[i].sale_price !=undefined)
            {
                ScrabData.sale_price = ws[i].sale_price;
            }
            else
            {
              ScrabData.sale_price = 0;
            }
                if(ws[i].noon_price_min !=undefined)
            {
                ScrabData.noon_price_min = ws[i].noon_price_min;
            }
            else
            {
              ScrabData.noon_price_min = null;
            }
                if(ws[i].noon_price_max !=undefined)
            {
                ScrabData.noon_price_max = ws[i].noon_price_max;
            }
            else
            {
              ScrabData.noon_price_max = null;
            }
                if(ws[i].seller_price_min !=undefined)
            {
                ScrabData.seller_price_min = ws[i].seller_price_min;
            }
            else
            {
              ScrabData.seller_price_min = null;
            }
                if(ws[i].seller_price_max !=undefined)
            {
                ScrabData.seller_price_max = ws[i].seller_price_max;
            }
            else
            {
              ScrabData.seller_price_max = null;
            }
       
          
                if(ws[i].is_active !=undefined)
            {
                ScrabData.is_active = ws[i].is_active;
            }
            else
            {
              ScrabData.is_active = 0;
            }
                if(ws[i].warranty !=undefined)
            {
                ScrabData.warranty = ws[i].warranty;
            }
            else
            {
              ScrabData.warranty = null;
            }
                if(ws[i].stock_fbn_net !=undefined)
            {
                ScrabData.stock_fbn_net = ws[i].stock_fbn_net;
            }
            else
            {
              ScrabData.stock_fbn_net = null;
            }
                if(ws[i].stock_xdock_gross !=undefined)
            {
                ScrabData.stock_xdock_gross = ws[i].stock_xdock_gross;
            }
            else
            {
              ScrabData.stock_xdock_gross = null;
            }
                if(ws[i].stock_xdock_net !=undefined)
            {
                ScrabData.stock_xdock_net = ws[i].stock_xdock_net;
            }
            else
            {
              ScrabData.stock_xdock_net = null;
            }
                if(ws[i].mp_code !=undefined)
            {
                ScrabData.mp_code = ws[i].mp_code;
            }
            else
            {
              ScrabData.mp_code = null;
            }
                if(ws[i].noon_status !=undefined)
            {
                ScrabData.noon_status = ws[i].noon_status;
            }
            else
            {
              ScrabData.noon_status = null;
            }

            
     

             ScrabData.CreatedBy = this.GenericUpload.SessionInfo.PageInfo.userId;

            this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString + "(\'" + ScrabData.country_code + "\',\'" +ScrabData.id_partner + "\',\'" +ScrabData.partner_sku + "\',\'" +ScrabData.partner_barcodes + "\',\'" +ScrabData.psku_code + "\',\'" +ScrabData.noon_sku + "\',\'" +ScrabData.price + "\',\'" +ScrabData.sale_price + "\',\'" +ScrabData.noon_price_min + "\',\'" +ScrabData.noon_price_max + "\',\'" +ScrabData.seller_price_min + "\',\'" +ScrabData.seller_price_max + "\',\'" +ScrabData.is_active + "\',\'" +ScrabData.warranty + "\',\'" +ScrabData.stock_fbn_net + "\',\'" +ScrabData.stock_xdock_gross + "\',\'" +ScrabData.stock_xdock_net + "\',\'" +ScrabData.mp_code + "\',\'" +ScrabData.noon_status + "\',\'" +this.GenericUpload.DataModel.Data.PanelInfo.Name + "\',\'" + ScrabData.CreatedBy + "\')";

            if(i < (ws.length - 1))
            {
              this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString+"," 
            }
            this.GenericUpload.DataModel.Data.GenericInputCount +=1;
          }
          
           this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString+";"
          
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log(this.GenericUpload.DataModel.Data.QueryString);  
          this.GenericUpload.PageLoad = false;
        
        } catch (e) {
          console.log(e); 
            this.GenericUpload.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },

 importStoreUSExcel(e) {

      const files = e.target.files;
      this.GenericUpload.PageLoad = true;
      this.GenericUpload.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.GenericUpload.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the dat   a of the first sheet
          const excellist = []; // Clear received data

          this.GenericUpload.DataModel.Data.GenericInputCount = 0 ;
          this.GenericUpload.DataModel.Data.QueryString = "INSERT INTO `StoreUSInventoryTemp` (`sku`, `vendor`, `price`, `enabled`, `weight`, `shippable`, `stockLevel`,`Panel`,`createdBy`) VALUES ";

          for (var i = 0; i < ws.length; i++) {
            var ScrabData={
              sku:null,
              vendor:null,
              price:null,
              enabled:null,
              weight:null,
              shippable:null,
              stockLevel:null,
              Panel:null,
              CreatedBy:null
            }

            if(ws[i].sku !=undefined)
            {
                ScrabData.sku = ws[i].sku;
            }
            else
            {
              ScrabData.sku = null;
            }

            if(ws[i].vendor !=undefined)
            {
                ScrabData.vendor = ws[i].vendor;
            }
            else
            {
              ScrabData.vendor = null;
            }

            if(ws[i].price !=undefined)
            {
                ScrabData.price = ws[i].price;
            }
            else
            {
              ScrabData.price = null;
            }
                if(ws[i].enabled !=undefined)
            {
                ScrabData.enabled = ws[i].enabled;
            }
            else
            {
              ScrabData.enabled = null;
            }
                      if(ws[i].weight !=undefined)
            {
                ScrabData.weight = ws[i].weight;
            }
            else
            {
              ScrabData.weight = null;
            }
                      if(ws[i].shippable !=undefined)
            {
                ScrabData.shippable = ws[i].shippable;
            }
            else
            {
              ScrabData.shippable = null;
            }
                      if(ws[i].stockLevel !=undefined)
            {
                ScrabData.stockLevel = ws[i].stockLevel;
            }
            else
            {
              ScrabData.stockLevel = null;
            }
                

             ScrabData.CreatedBy = this.GenericUpload.SessionInfo.PageInfo.userId;

            this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString + "(\'" + ScrabData.sku + "\',\'" +ScrabData.vendor + "\',\'" +ScrabData.price + "\',\'" +ScrabData.enabled + "\',\'" +ScrabData.weight + "\',\'" +ScrabData.shippable + "\',\'" +ScrabData.stockLevel + "\',\'" +this.GenericUpload.DataModel.Data.PanelInfo.Name + "\',\'" + ScrabData.CreatedBy + "\')";

            if(i < (ws.length - 1))
            {
              this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString+"," 
            }
            this.GenericUpload.DataModel.Data.GenericInputCount +=1;

          }

          
           this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString+";"

          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log(this.GenericUpload.DataModel.Data.QueryString);  
          this.GenericUpload.PageLoad = false;
          console.log(headers); 
          // this.GenericUpload.DataModel.Data.QueryString = JSON.stringify(this.GenericUpload.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            this.GenericUpload.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },

importJokokaExcel(e) {

      const files = e.target.files;
      this.GenericUpload.PageLoad = true;
      this.GenericUpload.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.GenericUpload.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the dat   a of the first sheet
          const excellist = []; // Clear received data

          this.GenericUpload.DataModel.Data.GenericInputCount = 0 ;

// JokokaInventoryTemp

                    
          this.GenericUpload.DataModel.Data.QueryString = "INSERT INTO `JokokaInventoryTemp` (`CustomerID`, `Model`, `Quantity`, `Price`,`Panel`,`createdBy`) VALUES ";

          for (var i = 0; i < ws.length; i++) {
            var ScrabData={
              CustomerID:null,
              Model:null,
              Quantity:null,
              Price:null
            }

            if(ws[i].CustomerID !=undefined)
            {
                ScrabData.CustomerID = ws[i].CustomerID;
            }
            else
            {
              ScrabData.CustomerID = null;
            }

            if(ws[i].Model !=undefined)
            {
                ScrabData.Model = ws[i].Model;
            }
            else
            {
              ScrabData.Model = null;
            }

            if(ws[i].Quantity !=undefined)
            {
                ScrabData.Quantity = ws[i].Quantity;
            }
            else
            {
              ScrabData.Quantity = null;
            }
                if(ws[i].Price !=undefined)
            {
                ScrabData.Price = ws[i].Price;
            }
            else
            {
              ScrabData.Price = null;
            }
                
             ScrabData.CreatedBy = this.GenericUpload.SessionInfo.PageInfo.userId;

            this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString + "(\'" + ScrabData.CustomerID + "\',\'" +ScrabData.Model + "\',\'" +ScrabData.Quantity + "\',\'" +ScrabData.Price + "\',\'" +this.GenericUpload.DataModel.Data.PanelInfo.Name + "\',\'" + ScrabData.CreatedBy + "\')";

            if(i < (ws.length - 1))
            {
              this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString+"," 
            }
            this.GenericUpload.DataModel.Data.GenericInputCount +=1;
            
          }

          
           this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString+";"
 
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log(this.GenericUpload.DataModel.Data.QueryString);  
          this.GenericUpload.PageLoad = false;
 
        } catch (e) {
          console.log(e); 
            this.GenericUpload.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },


 previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       }


  }
}
</script>